import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';

const CustomBoatLeadForm = ({ formData, errors, handleChange }) => {
  return (
    <div className="boat-lead-form__form">
      <div className="form-group-row">
        <div className="form-group">
          <input
            type="text"
            name="fullName"
            value={formData.fullName}
            onChange={handleChange}
            placeholder="Full Name*"
            className={errors.fullName ? 'error' : ''}
          />
          <div className="error-message-container">
            <p className="error-message">{errors.fullName}</p>
          </div>
        </div>

        <div className="form-group">
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Email*"
            className={errors.email ? 'error' : ''}
          />
          <div className="error-message-container">
            <p className="error-message">{errors.email}</p>
          </div>
        </div>
      </div>

      <div className="form-group-row">
        <div className="form-group">
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="Phone*"
            className={errors.phone ? 'error' : ''}
          />
          <div className="error-message-container">
            <p className="error-message">{errors.phone}</p>
          </div>
        </div>

        <div className="form-group">
          <DatePicker
            selected={formData.date ? new Date(formData.date) : null}
            onChange={date => handleChange({ target: { name: 'date', value: date ? date.toISOString().split('T')[0] : '' } })}
            dateFormat="MM/dd/yyyy"
            placeholderText="mm/dd/yyyy"
            minDate={new Date()}
            className={errors.date ? 'error' : ''}
            customInput={
              <div style={{ position: 'relative', width: '100%' }}>
                <input
                  type="text"
                  value={formData.date}
                  readOnly
                  className={`custom-datepicker-input${errors.date ? ' error' : ''}`}
                  style={{ width: '100%', paddingRight: 32 }}
                  placeholder="mm/dd/yyyy"
                />
                <span className="calendar-icon">
                  <FontAwesomeIcon icon={faCalendarAlt} />
                </span>
              </div>
            }
          />
          <div className="error-message-container">
            <p className="error-message">{errors.date}</p>
          </div>
        </div>
      </div>

      <div className="form-group">
        <textarea
          name="message"
          value={formData.message}
          onChange={handleChange}
          placeholder="What would you like to know? (e.g. availability, special requests, itinerary...)"
          className={errors.message ? 'error' : ''}
        />
        <div className="error-message-container">
          <p className="error-message">{errors.message}</p>
        </div>
      </div>
    </div>
  );
};

export default CustomBoatLeadForm;
